import React, { useState, useEffect } from 'react';
import { FaRegWindowClose, FaExclamationTriangle } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  InputStyles,
  ModalNoteStyles,
} from '../../../../SharedStyles';

const LoadLimitModal = (props) => {
  const { handleCloseModal, handleDataChange } = props;
  const { strings } = AppMeterGroupsService;
  const [loadLimit, setLoadLimit] = useState('');

  useEffect(() => {
    setLoadLimit(props.loadLimit);
  }, [props.loadLimit]);

  const closeModal = () => {
    handleCloseModal();
  };

  const handleChange = (e) => {
    setLoadLimit(e.target.value);
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    handleDataChange('loadLimit', loadLimit);
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.loadLimitTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0'>
            <p>{strings.loadLimitContent}</p>
          </ModalItemStyles>
          {/* Section */}
          <form id='modalForm' onSubmit={handleSaveInfo}>
            <ModalItemStyles>
              <InputStyles
                type='number'
                onChange={handleChange}
                name='loadLimit'
                placeholder={strings.loadLimitPlaceholder}
                value={loadLimit || ''}
                required
              />
            </ModalItemStyles>
          </form>
          {/* Note Section */}
          <ModalNoteStyles>
            <p className='Warning-modal'>
              <FaExclamationTriangle />
              <span className='Warning-bold'>{strings.warning}</span> -{' '}
              {strings.loadLimitWarning}
            </p>
          </ModalNoteStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          formSubmit='modalForm'
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default LoadLimitModal;
